module.exports = __webpack_public_path__ + "static/media/wrecker_turquoise.c10f7260.svg";